var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSi2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 135"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 105",
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#D1EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.1969 13.4215H10.075C9.15243 13.4215 8.40161 14.1723 8.40161 15.0949V35.1762C8.40161 36.0988 9.15243 36.8496 10.075 36.8496H40.1969C41.1195 36.8496 41.8704 36.0988 41.8704 35.1762V15.0949C41.8704 14.1723 41.1195 13.4215 40.1969 13.4215Z",
    fill: "#387CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7688 35.7342C13.8459 35.7342 11.035 35.3532 8.40161 34.6587V35.1764C8.40161 36.099 9.15243 36.8498 10.075 36.8498H40.1969C41.1195 36.8498 41.8704 36.099 41.8704 35.1764V21.7415C38.0823 29.9123 28.2742 35.7342 16.7688 35.7342Z",
    fill: "#174EB6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.40161 18.9996H41.8704V24.5778H8.40161V18.9996Z",
    fill: "#F4B045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.6328 15.6528H11.7484V16.7685H10.6328V15.6528ZM12.8641 15.6528H13.9797V16.7685H12.8641V15.6528ZM15.0953 15.6528H16.2109V16.7685H15.0953V15.6528ZM17.3266 15.6528H18.4422V16.7685H17.3266V15.6528ZM39.0813 31.2716H34.6187C34.4708 31.2716 34.3289 31.3304 34.2243 31.435C34.1197 31.5396 34.0609 31.6815 34.0609 31.8294V34.0606C34.0609 34.2086 34.1197 34.3505 34.2243 34.4551C34.3289 34.5597 34.4708 34.6185 34.6187 34.6185H39.0813C39.2292 34.6185 39.3711 34.5597 39.4757 34.4551C39.5803 34.3505 39.6391 34.2086 39.6391 34.0606V31.8294C39.6391 31.6815 39.5803 31.5396 39.4757 31.435C39.3711 31.3304 39.2292 31.2716 39.0813 31.2716ZM32.3875 31.2716H27.925C27.7771 31.2716 27.6352 31.3304 27.5306 31.435C27.426 31.5396 27.3672 31.6815 27.3672 31.8294V34.0606C27.3672 34.2086 27.426 34.3505 27.5306 34.4551C27.6352 34.5597 27.7771 34.6185 27.925 34.6185H32.3875C32.5354 34.6185 32.6773 34.5597 32.7819 34.4551C32.8865 34.3505 32.9453 34.2086 32.9453 34.0606V31.8294C32.9453 31.6815 32.8865 31.5396 32.7819 31.435C32.6773 31.3304 32.5354 31.2716 32.3875 31.2716ZM11.1906 32.3872H19.5578V33.5028H11.1906V32.3872Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi2);
export default __webpack_public_path__ + "static/media/si2.f478aed9f3b6bcbda5a7f632840f25c6.svg";
export { ForwardRef as ReactComponent };